import {
  PopoverBody,
  PopoverContent,
  PopoverFooter,
  Flex,
  ButtonGroup,
  Button,
} from '@frontend/legacy-components';

type ConfirmAddQuantitiesPopoverContentProps = {
  onConfirm: () => void;
  onCancel: () => void;
  submitButtonRef: React.LegacyRef<HTMLButtonElement>;
};

export const ConfirmAddQuantitiesPopoverContent = ({
  onConfirm,
  onCancel,
  submitButtonRef,
}: ConfirmAddQuantitiesPopoverContentProps) => {
  return (
    <PopoverContent>
      <PopoverBody>
        These quantities will be added to all selected line items. <br />
        This cannot be undone.
      </PopoverBody>
      <PopoverFooter>
        <Flex justify="flex-end">
          <ButtonGroup size="sm">
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button onClick={onConfirm} ref={submitButtonRef}>
              Update Quantities
            </Button>
          </ButtonGroup>
        </Flex>
      </PopoverFooter>
    </PopoverContent>
  );
};
